import type { CSSVariablesResolver } from '@mantine/core'
import { createTheme, rem } from '@mantine/core'

export const themeOverride = createTheme({
  fontFamily: 'Montserrat, sans-serif',

  headings: {
    sizes: {
      h1: {
        fontSize: rem(24),
      },
      h2: {
        fontSize: rem(20),
      },
      h4: {
        fontSize: rem(14),
      },
    },
  },

  other: {
    colors: {
      bgMain: '#F9F9F9',
      black: '#2A2A2A',
      blue: '#7D84DF',
      blueDark: '#998FC7',
      brightGreen: '#AACB4E',
      darkGreen: '#204954',
      darkGrey: '#777777',
      darkRed: '#E94C55',
      extraLightPurple: '#AEA5D2',
      green: '#1EA896',
      grey: '#BEBEBE',
      greyBg: '#EAEFF0',
      lightGrey: '#EEEEEE',
      mediumPurple: '#8B79DD',
      orange: '#FD9B3D',
      primaryDarkGreen: '#0F554B',
      purple: '#372B58',
      purpleDark: '#2D2347',
      purpleTint: '#E8E9F8',
      red: '#FF715B',
      switch: '#C4E9D7',
      violet: '#C7CBFF',
      white: '#FFFFFF',
    },
  },
})

export const themeResolver: CSSVariablesResolver = theme => ({
  dark: {},
  light: {
    '--mantine-other-colors-bg-main': theme.other.colors.bgMain,
    '--mantine-other-colors-black': theme.other.colors.black,
    '--mantine-other-colors-blue': theme.other.colors.blue,
    '--mantine-other-colors-bright-green': theme.other.colors.brightGreen,
    '--mantine-other-colors-dark-blue': theme.other.colors.blueDark,
    '--mantine-other-colors-dark-green': theme.other.colors.darkGreen,
    '--mantine-other-colors-dark-grey': theme.other.colors.darkGrey,
    '--mantine-other-colors-dark-red': theme.other.colors.darkRed,
    '--mantine-other-colors-extra-light-purple':
      theme.other.colors.extraLightPurple,
    '--mantine-other-colors-green': theme.other.colors.green,
    '--mantine-other-colors-grey': theme.other.colors.grey,
    '--mantine-other-colors-grey-bg': theme.other.colors.greyBg,
    '--mantine-other-colors-light-grey': theme.other.colors.lightGrey,
    '--mantine-other-colors-medium-purple': theme.other.colors.mediumPurple,
    '--mantine-other-colors-orange': theme.other.colors.orange,
    '--mantine-other-colors-primary-dark-green':
      theme.other.colors.primaryDarkGreen,
    '--mantine-other-colors-purple': theme.other.colors.purple,
    '--mantine-other-colors-purple-dark': theme.other.colors.purpleDark,
    '--mantine-other-colors-purple-tint': theme.other.colors.purpleTint,
    '--mantine-other-colors-red': theme.other.colors.red,
    '--mantine-other-colors-switch': theme.other.colors.switch,
    '--mantine-other-colors-violet': theme.other.colors.violet,
    '--mantine-other-colors-white': theme.other.colors.white,
  },
  variables: {},
})
